import { useCallback } from "react";

interface IconProps {
  className?: string;
  onClick?: () => void;
}

export const IconLoading: React.FC<IconProps> = (props) => {
  const { className, onClick } = props;

  const handleClick = useCallback(() => {
    if (onClick && typeof onClick === "function") {
      onClick();
    }
  }, [onClick]);

  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      onClick={handleClick}
    >
      <path
        className="st0"
        d="M13.1,18.7c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c0,0,0,0,0,0c-1.2,0-2.2-1-2.2-2.2
	C10.9,19.7,11.9,18.7,13.1,18.7z M6.1,15.3c1.5,0,2.8,1.2,2.8,2.8c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8
	C3.4,16.6,4.6,15.3,6.1,15.3z M19,15.9c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c0,0,0,0,0,0c-1.2,0-2.2-1-2.2-2.2
	C16.8,16.9,17.8,15.9,19,15.9z M21.5,11.2c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.7,1.7-1.7,1.7c0,0,0,0,0,0c-0.9,0-1.7-0.7-1.7-1.7
	C19.8,12,20.5,11.2,21.5,11.2z M3.7,7.5c1.5,0,2.8,1.2,2.8,2.8s-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8S2.1,7.5,3.7,7.5z M20.7,6.7
	c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0c-0.6,0-1.1-0.5-1.1-1.1C19.5,7.2,20,6.7,20.7,6.7z M9.8,0.9
	c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3S6.4,6.1,6.4,4.2S7.9,0.9,9.8,0.9z M18.1,4.2c0.3,0,0.6,0.2,0.6,0.6c0,0.3-0.2,0.6-0.6,0.6
	c0,0,0,0,0,0c-0.3,0-0.6-0.2-0.6-0.6C17.6,4.5,17.8,4.2,18.1,4.2z"
      />
    </svg>
  );
};
